import { Body2 } from 'stories/elements/Typography/Text'
import Breadcrumbs from 'components/modules/SEO/Breadcrumbs'
import styled from 'styled-components'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import {
    seoSubjectsRoute,
    subjectsTopicRoute,
    taxonomyLevelOne,
    taxonomyLevelThree,
    taxonomyLevelTwo,
} from 'lib/constants/routes'
import _useTranslation from 'lib/hooks/_useTranslation'

const Container = styled.div<{ minimalizeBreadCrumbs?: boolean }>`
    width: 100%;
    padding: ${({ minimalizeBreadCrumbs }) => (minimalizeBreadCrumbs ? 0 : '5px 25px')};
`

const EmptyBreadcrumbsContainer = styled(Body2)`
    padding-bottom: 10px;

    @media (max-width: 750px) {
        padding: 5px 0 0 5px;
    }
`

interface Props {
    knowSeoInfo: KnowSeoInfo | null
    referrerScreen?: string
    minimalizeBreadCrumbs?: boolean
    showArrows?: boolean
}

const OverhaulKnowSEOBreadcrumbs = ({ knowSeoInfo, referrerScreen, minimalizeBreadCrumbs, showArrows }: Props) => {
    const { t: tCommon } = _useTranslation('common')

    if (!knowSeoInfo) return null

    const {
        topicsPath,
        know: { subjects },
    } = knowSeoInfo

    const initialSubject = subjects?.length ? subjects[0] : null

    let parts: { label: string; href: string; isNotALink?: true }[] =
        topicsPath?.length && topicsPath[0] && topicsPath[1]
            ? [
                  {
                      label: topicsPath[0].name,
                      href: taxonomyLevelOne(topicsPath[0].slug),
                  },
                  {
                      label: topicsPath[1].name,
                      href: taxonomyLevelTwo(topicsPath[0].slug, topicsPath[1].slug),
                  },
              ]
            : []

    if (topicsPath?.length >= 3 && topicsPath[2]) {
        parts = [
            ...parts,
            {
                label: topicsPath[2].name,
                href: taxonomyLevelThree(topicsPath[0].slug, topicsPath[2].slug),
            },
            {
                label: knowSeoInfo?.title,
                href: '',
                isNotALink: true,
            },
        ]
    } else {
        parts = [
            ...parts,
            {
                label: knowSeoInfo?.title,
                href: '',
                isNotALink: true,
            },
        ]
    }

    if (initialSubject) {
        parts = [
            {
                label: tCommon('common/navBarMenuSubjectMenuItem'),
                href: seoSubjectsRoute,
            },
            {
                label: initialSubject.name,
                href: subjectsTopicRoute(initialSubject),
            },
            ...parts,
        ]
    }

    if (minimalizeBreadCrumbs) {
        parts.pop()
    }

    const showBreadcrumbs = !!knowSeoInfo

    return (
        <Container minimalizeBreadCrumbs={minimalizeBreadCrumbs}>
            {showBreadcrumbs ? (
                <Breadcrumbs
                    breadcrumbs={parts}
                    know={knowSeoInfo.know}
                    referrerScreen={referrerScreen}
                    minimalizeBreadCrumbs={minimalizeBreadCrumbs}
                    showArrows={showArrows}
                    scrollable
                />
            ) : (
                <EmptyBreadcrumbsContainer />
            )}
        </Container>
    )
}

export default OverhaulKnowSEOBreadcrumbs
